import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { MaterialModule } from "./material.module";
import { FaLibraryModule } from "./fa-library.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { TranslateModule } from "@ngx-translate/core";
import { NgxDropzoneModule } from 'ngx-dropzone';

import { ArrayFilterPipe } from "./pipes/array-filter.pipe";
import { FormatAmountPipe } from './pipes/format-amount.pipe';
import { FormatPercentPipe } from './pipes/format-percent.pipe';
import { ArrayTextFilterPipe } from './pipes/array-text-filter.pipe';
import { PartitionsFlagFilterPipe } from './pipes/partitions-flag-filter.pipe';
import { ReplacePipe } from './pipes/replace.pipe';
import { ReplaceReturnLinePipe } from './pipes/replace-ReturnLine.pipe';

import { HapyCursorComponent } from "./components/hapy-cursor/hapy-cursor.component";
import { ConfirmDialogComponent } from "./dialogs/confirm-dialog/confirm-dialog.component";
import { TooltipComponent } from './components/tooltip/tooltip.component';
import { PartitionsTreeNodeComponent } from "./components/partitions-tree/partitions-tree-node/partitions-tree-node.component";
import { PartitionsTreeComponent } from "./components/partitions-tree/partitions-tree.component";
import { PartitionsSunburstComponent } from "./components/partitions-sunburst/partitions-sunburst.component";
import { UploadMultiComponent } from './components/uploader/upload-multi/upload-multi.component';
import { UploadSingleComponent } from './components/uploader/upload-single/upload-single.component';
import { FilesListComponent } from './components/uploader/files-list/files-list.component';
import { UploadProgressComponent } from './components/uploader/upload-progress/upload-progress.component';
import { PartitionsTreeCardComponent } from './components/partitions-tree/partitions-tree-card/partitions-tree-card.component';
import { PartitionsSunburstCardComponent } from './components/partitions-sunburst/partitions-sunburst-card/partitions-sunburst-card.component';
import { SearchPipe } from './pipes/search-pipe.pipe';
import { SimplebarAngularModule } from 'simplebar-angular';
import { SafePipe } from './pipes/safe.pipe';
import { DragDropDirective } from './directives/drag-drop.directive';

@NgModule({
    declarations: [
        HapyCursorComponent,
        ConfirmDialogComponent,
        TooltipComponent,

        ArrayFilterPipe,
        FormatAmountPipe,
        FormatPercentPipe,
        ArrayTextFilterPipe,
        PartitionsFlagFilterPipe,
        SearchPipe,
        SafePipe,
        ReplacePipe,
        ReplaceReturnLinePipe,

        PartitionsTreeNodeComponent,
        PartitionsTreeComponent,
        PartitionsSunburstComponent,
        PartitionsTreeCardComponent,
        PartitionsSunburstCardComponent,

        UploadMultiComponent,
        UploadSingleComponent,
        FilesListComponent,
        UploadProgressComponent,
        DragDropDirective
    ],
    entryComponents: [
        ConfirmDialogComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        FaLibraryModule,
        ReactiveFormsModule,
        TranslateModule,
        NgxDropzoneModule,
        SimplebarAngularModule,
    ],
    exports: [
        MaterialModule,
        FaLibraryModule,
        TranslateModule,
        FontAwesomeModule,
        DragDropDirective,

        HapyCursorComponent,
        TooltipComponent,

        PartitionsTreeComponent,
        PartitionsSunburstComponent,
        PartitionsTreeCardComponent,
        PartitionsSunburstCardComponent,

        UploadMultiComponent,
        UploadSingleComponent,
        FilesListComponent,

        ArrayFilterPipe,
        FormatAmountPipe,
        FormatPercentPipe,
        ArrayTextFilterPipe,
        PartitionsFlagFilterPipe,
        SearchPipe,
        SimplebarAngularModule,
        SafePipe,
        ReplacePipe,
        ReplaceReturnLinePipe,

    ]
})
export class SharedModule {}
